// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__-jY0u","select":"Header_select__31Gi1","clinic":"Header_clinic__VG4zp"};